import { render, staticRenderFns } from "./PersonChange.vue?vue&type=template&id=7bdebd3c&scoped=true&"
import script from "./PersonChange.vue?vue&type=script&lang=js&"
export * from "./PersonChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdebd3c",
  null
  
)

export default component.exports